var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccessSpecial = function SvgSuccessSpecial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Success_Special_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 84c18.778 0 34-15.222 34-34S70.778 16 52 16 18 31.222 18 50s15.222 34 34 34Z",
    fill: "url(#Success_Special_svg__b)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Success_Special_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m34 51.09 3.342-3.466 9.078 9.443L66.66 36 70 39.466 46.42 64 34 51.09Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Success_Special_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(64.983 2.69 38.014) scale(91.0412)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6794C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#305992"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Success_Special_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(34 36)",
    d: "M0 0h36v28H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Success_Special_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_2833"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2_2833",
    result: "shape"
  })))));
};
export default SvgSuccessSpecial;